export default class FacebookHelper {

  constructor(options) {
    window.fbAsyncInit = () => {
      FB.init({
        appId: options.appId,
        version: 'v2.8'
      })
    }
    this.createTag(document, 'script')
  }

  createTag(d, s) {
    var js, fjs = d.getElementsByTagName(s)[0]
    js = d.createElement(s)
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  }

  login(callback) {
    FB.login(loginResponse => {
      if (loginResponse.status === 'connected') {
        FB.api(
          '/me?fields=gender,name,verified,email',
          dataResponse => {
            callback(loginResponse, dataResponse)
          }
        )
      } else {
        callback(loginResponse)
      }
    }, {
      return_scopes: true
    })
  }
}